import en from "./translations/en.json"
import ja from "./translations/ja.json"

const translations = { en, ja }

export default translations
